import {IRoutableModule} from '../../router/routing.infra';
import {BrowserNotSupportedView} from './browser-not-supported.view';
import {browserNotSupportedRouteLoader} from './browser-not-supported.loader';

export default {
    loader: browserNotSupportedRouteLoader,
    Component: BrowserNotSupportedView,
    storeAs: 'browserNotSupportedStore'
} as IRoutableModule;
